import React from "react";
const LibrarySong = ({
  song,
  songs,
  setSongs,
  id,
  audioRef,
  setCurrentSong,
  isPlaying,
}) => {
  // song choose
  const songSelectHandler = async () => {
    const selectedSong = songs.filter((state) => state.id === id);
    setCurrentSong({ ...selectedSong[0] });
    //setActiveSongs
    const newSong = songs.map((song) => {
      if (song.id === id) {
        return {
          ...song, // Rest of the info let it remain same
          active: true,
        };
      } else {
        return {
          ...song, // Rest of the info let it remain same
          active: false,
        };
      }
    });
    await setSongs(newSong);
    if (isPlaying) audioRef.current.play();
    // if (isPlaying) {
    //   const playPromise = audioRef.current.play();
    //   if (playPromise !== undefined) {
    //     // The song is not loaded then wait and then play else keep it paused
    //     playPromise.then((audio) => {
    //       audioRef.current.play();
    //     });
    //   }
    // }
  };
  //Active state active

  return (
    <div
      onClick={songSelectHandler}
      className={`library-song ${song.active ? "selected" : ""}`}
    >
      <img src={song.cover} alt={song.name}></img>
      <div className="song-descriptor">
        <h3>{song.name}</h3>
        <h4>{song.artist}</h4>
      </div>
    </div>
  );
};
export default LibrarySong;
